import { OrdenItem } from '@services/business/invoice/entities';
import {
  ApiInterface,
  EmptyObject,
  PaginatedQueryParams,
  PaginatedResponse,
} from '@stetamalo/cloud-platform/catalog/api';
import { ApiConfig } from 'services/support/utils/types/api-config';
export type Interface = ApiInterface<{
  response: PaginatedResponse<OrdenItem>;
  pathParams: EmptyObject;
  body: EmptyObject;
  claims: { tenantId: string };
  queryParams: PaginatedQueryParams & { dateAppointment: string };
}>;

export const config: ApiConfig<Interface> = {
  name: 'api-list-invoice-item-appointment',
  method: 'GET',
  basePath: 'orden',
  path: '/appointment',
  tablePermission: 'read',
  scope: 'RECEPTIONIST',
};
